module.exports = __webpack_public_path__ + "static/img/product.596ff99a.png";